"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgOutlook(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M7.185 9.176c-.505 0-.908.238-1.205.712-.297.474-.446 1.101-.446 1.882 0 .792.15 1.419.446 1.879.297.462.687.69 1.17.69.496 0 .89-.223 1.182-.671.29-.448.437-1.07.437-1.865 0-.83-.141-1.475-.424-1.936-.283-.46-.67-.69-1.16-.69",
    fill: "inherit"
  }), React.createElement("path", {
    d: "M13.972 0v24L0 21.07V2.705L13.972 0zm9.886 7.844v8.628c0 .94-.601 1.333-1.277 1.333h-7.606v-6.38l1.498 1.029c.21.155.465 0 .465 0-.253.155 6.92-4.61 6.92-4.61zM7.143 7.803c-.977 0-1.76.394-2.353 1.183-.592.789-.888 1.822-.888 3.1 0 1.209.292 2.19.875 2.943.583.753 1.336 1.13 2.262 1.13.95 0 1.72-.39 2.31-1.167.59-.777.886-1.8.885-3.07 0-1.237-.284-2.232-.854-2.987-.569-.756-1.315-1.132-2.237-1.132zm15.89-2.811c.297 0 .823.403.823.966l-7.06 4.761a.422.422 0 01-.181 0l-1.64-1.033V4.992z",
    fill: "inherit"
  })));
}

var _default = SvgOutlook;
exports.default = _default;